import React from 'react';
import {Text, View} from 'react-native';
import {useSelector} from 'react-redux';

////////////// utils
import {classicPhotoVideoCompletionEvent} from 'src/Utils/huntFunctions_classic';

import {apiCheckAnyChallenge} from 'src/Utils/apiCalls';

/////////////// components
import {navigationRef} from 'src/Nav/navigationHelpers';
import {BodyText, ClassicChallengeCard} from 'src/Modules/CommonView';
import {useUserId} from '../../Hooks/reduxHooks';
import CustomActivityIndicator from '../../Modules/CommonView/CustomActivityIndicator';
import {saveGroupPosition} from '../../Utils/huntFunctions';

const basePhotoUrl = 'photos.letsroam.com';

const ChallengesList = ({
  almostEndOfHunt,
  availableChallenges,
  completedChallenges,
  challengeHeader,
  challengeHeaderStyle = {},
  challengeHeaderBody,
  challengeHeaderBodyStyle = {},
}) => {
  const groupInfo = useSelector((state) => state.groupInfo);
  const location = useSelector((state) => state.location);

  const allChallenges = useSelector(
    (state) => state.game_v2?.allChallenges || {},
  );

  const userId = useUserId();

  const handlePhotoComplete = ({photoUrl, shareUUID, challenge}) => {
    const {eventId = null} = groupInfo;
    const {challengeId, question} = challenge;

    classicPhotoVideoCompletionEvent({
      photoUrl: photoUrl,
      challengeId,
      userId,
      groupId: groupInfo?.groupId,
      shareUUID,
      description: question,
      eventId,
      challenge,
    });
  };

  const handleVideoComplete = ({photoUrl, thumbnail, shareUUID, challenge}) => {
    const {eventId = null, groupId} = groupInfo;
    const {challengeId, question} = challenge;

    classicPhotoVideoCompletionEvent({
      photoUrl: photoUrl,
      thumbnail: thumbnail,
      challengeId,
      userId,
      groupId,
      shareUUID,
      description: question,
      eventId,
      challenge,
    });
  };

  const handleSelectChallenge = (challenge) => {
    const {type} = challenge;

    const {region = {}} = location;
    const {latitude = 0, longitude = 0} = region;

    saveGroupPosition({latitude, longitude}, groupInfo?.groupId);

    if (type === 'photo' || type === 'video') {
      return navigationRef.navigate('PhotoVideoCamera', {
        onCapture: (data) => {
          if (type === 'photo') {
            handlePhotoComplete({
              photoUrl: data?.downloadURL,
              shareUUID: data?.shareUUID,
              challenge,
            });
          } else if (type === 'video') {
            handleVideoComplete({
              thumbnail: data?.thumbnail,
              photoUrl: data?.downloadURL,
              shareUUID: data?.shareUUID,
              challenge,
            });
          }
        },
        onScore: async (data) => {
          const checkParams = {
            challenge_id: (challenge.challengeId || '').replace('cc_', ''),
            photo_url: data?.downloadURL,
            shareUUID: challenge.shareUUID,
            user_id: userId,
            group_id: groupInfo?.groupId,
            share_UUID: data?.shareUUID,
          };
          console.log({checkParams});
          const scoringResponse = await apiCheckAnyChallenge(checkParams);
          console.log({scoringResponse});
          return scoringResponse;
        },
        onFailScore: (data) => {
          // return Alert.alert('You failed the challenge!');
          const {photo_grade = {}, lr_app_challenge_completion_id = 0} = data;
          const {
            feedback_title = 'Close but no Cigar!!!!',
            feedback_body = 'We were not able to detect the required elements in the image!',
          } = photo_grade;

          navigationRef.navigate('ConfirmModal', {
            handleConfirm: async () => {
              navigationRef.goBack();
              handleSelectChallenge(challenge);
            },
            confirmText: 'Try Again',
            cancelText: 'Report Issue',
            handleCancel: () => {
              navigationRef.goBack();
              navigationRef.navigate('QuestionFeedback', {
                challenge,
                lr_app_challenge_completion_id,
                type: 'daily_challenge',
                userId,
                challenged_by_user: 1,
              });
            },
            thirdOption: 'Cancel',
            handleThird: () => {
              navigationRef.goBack();
            },
            confirmColor: global?.color?.orange,
            cancelColor: global?.color?.blue,
            titleText: feedback_title,
            titleImage: require('src/Images/sadTrophy.png'),
            titleBodyText: feedback_body,
          });
        },
        onReport: () => {
          navigationRef.navigate('ReportModal');
        },
        text: challenge.question,
        shareUUID: challenge.shareUUID,
        photoUrl: challenge.photoUrl,
        isVideo: type == 'video',
      });
    }

    if (
      [
        'multiple_choice',
        'true_false',
        'link',
        'fill_in_the_blank',
        'number_guesser',
        'numberguesser',
      ]?.includes(type)
    ) {
      console.log({challenge});
      return navigationRef.navigate('ChallengeAttemptModal', {
        challengeId: challenge.challengeId,
      });
    }

    if (type === 'location') {
      if (challenge?.completeTime && challenge?.required_checkout_location) {
        return navigationRef.navigate('LocationChallengeListModal', {
          locationId: challenge.locationId,
        });
      }

      return navigationRef.navigate('NavigationChallengeModal', {
        locationId: challenge.locationId,
      });
    }
  };

  const renderChallengeCard = (challenge, index) => {
    const {
      challengeId,
      name,
      type,
      question,
      points = 500,
      completeTime,
      groupPointsEarned = 0,
      challengeList = [],
      photoLarge,
      required_checkout_location,
      challenges = [],
    } = challenge;

    const photoLargeUrl = photoLarge
      ? `https://${basePhotoUrl}${photoLarge && photoLarge.substring(1)}`
      : '';

    const challengesComplete =
      (challengeList &&
        (
          (challengeList || []).filter((key) => {
            return allChallenges[key]?.completeTime;
          }) || []
        ).length) ||
      0;

    const totalLocationPoints =
      (challengeList &&
        (challengeList || []).reduce((sum, key) => {
          let challenge = challenges?.[key];
          return Math.round(challenge?.points || 0) + sum;
        }, challenge?.points || 0)) ||
      0;

    return (
      <ClassicChallengeCard
        testID={`card-${index}`}
        key={`cc_item_${challengeId}${challenge.index}`}
        containerStyle={
          required_checkout_location && almostEndOfHunt
            ? {borderColor: global?.color?.red, borderWidth: 3}
            : {}
        }
        title={
          type === 'location' ? (
            `${name}`
          ) : !!completeTime ? (
            <Text>
              {challenge.name || `Challenge`}
              <Text style={{fontWeight: '400'}}>{` - Complete`}</Text>
            </Text>
          ) : (
            challenge.name || `Challenge`
          )
        }
        text={
          type === 'location' ? (
            required_checkout_location ? (
              <Text>
                <Text style={{color: global?.color?.red}}>
                  Check in at the ending location!{' '}
                </Text>{' '}
                You need to check in here within the last{' '}
                {global?.checkoutTimeLimit} minutes of the hunt or after you
                finish 80% of challenges.
              </Text>
            ) : (
              `Complete the ${
                challengeList && challengeList?.length
              } challenges at this location and earn up to ${totalLocationPoints} points.`
            )
          ) : (
            question
          )
        }
        icon={
          type === 'photo'
            ? 'camera'
            : type === 'video'
            ? 'video-camera'
            : type === 'location'
            ? 'map-marker'
            : type === 'true_false'
            ? 'university'
            : type === 'multiple_choice'
            ? 'university'
            : type === 'fill_in_the_blank'
            ? 'university'
            : 'university'
        }
        backgroundColor={
          type === 'photo'
            ? global?.color?.orange
            : type === 'video'
            ? global?.color?.blue
            : type === 'location'
            ? global?.color?.black_30
            : global?.color?.teal
        }
        backgroundUrl={photoLargeUrl}
        label={
          type === 'location' ? `${totalLocationPoints} pts` : `${points} pts`
        }
        sublabel={groupPointsEarned && type !== 'location' ? 'earned' : ''}
        completed={
          type === 'location'
            ? challengesComplete === challengeList?.length
            : !!completeTime
        }
        completedIcon={'check'}
        completedIconColor={global?.color?.brightgreen}
        completedLabel={
          type === 'location'
            ? required_checkout_location
              ? false
              : `${challengesComplete}/${challengeList?.length}`
            : false
        }
        handlePress={() => {
          handleSelectChallenge(challenge);
        }}
      />
    );
  };

  if (!availableChallenges || !completedChallenges) {
    return (
      <View
        style={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: global?.color?.white,
        }}>
        <CustomActivityIndicator />
      </View>
    );
  }

  return (
    <View
      style={{
        backgroundColor: global?.color?.white1,
        marginTop: 5,
      }}>
      <View style={{marginVertical: 5}}>
        <BodyText
          text={challengeHeader || 'Hunt Challenges'}
          textStyle={{
            textAlign: 'center',
            fontWeight: '700',
            ...challengeHeaderStyle,
          }}
        />
        <BodyText
          text={
            challengeHeaderBody ||
            'Complete as many challenges as you can before time runs out'
          }
          textStyle={{
            textAlign: 'center',
            marginHorizontal: 50,
            lineHeight: 20,
            marginTop: 3,
            marginBottom: 5,
            ...challengeHeaderBodyStyle,
          }}
        />
      </View>
      <View>
        {!!availableChallenges?.length &&
          availableChallenges?.map?.((challenge, index) => {
            return renderChallengeCard(challenge, index);
          })}
      </View>
      {!!completedChallenges?.length && (
        <View style={{marginBottom: 5, marginTop: 20}}>
          <BodyText
            text="Completed Challenges"
            textStyle={{
              textAlign: 'center',
              marginHorizontal: 50,
              lineHeight: 20,
              marginTop: 3,
              marginBottom: 5,
              fontWeight: '700',
            }}
          />
        </View>
      )}
      <View>
        {!!completedChallenges?.length &&
          completedChallenges?.map?.((challenge, index) => {
            return renderChallengeCard(challenge, index);
          })}
      </View>
    </View>
  );
};

export default ChallengesList;
